// @file backendState from window object
const backendState = window.$backendState || window.ww.vueStartingState?.backendState || {}

export default backendState
